import React, { ReactElement } from 'react';
import { Route, Switch } from 'react-router-dom';
// import useFreshbot from '../../shared/hooks/useFreshbot';
import { RouteConfig } from '../../shared/models/route.models';
import RoutesConfig from './RoutesConfig';

const PublicRoutes = (): ReactElement => {
  // useFreshbot();
  return (
    <Switch>
      {
        RoutesConfig.publicRoutes.map(({ path, component }: RouteConfig): ReactElement => {
          return (
            <Route
              exact={true}
              key={path}
              path={path}
              component={component}
            />
          );
        },
        )
      }
    </Switch>
  );
};

export default PublicRoutes;
